
    /**
    * 商家入驻 名称校验
    * 
    **/
    
    // @ts-nocheck
    import request from '../utils/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    export class IReqApiFindCategoryManager25745 {
}
    export class IResApiFindCategoryManager25745 {
  code: number;
      data: {categoryName:string, managerName:string}[];
  message: string;
  success: boolean;
}
    const http: Serve<IReqApiFindCategoryManager25745, IResApiFindCategoryManager25745> = (data?) =>  request({
      method: 'GET',
      url: '/api/find/category/manager',
      params: data
    }) 
    export default http